import VenueManagementUrls from "../sources/api/urls";
import * as VenueManagementClient from "../sources/api/clients/vendorManagement";
import {
    mapGetReceivableByMonthyIdResponse
} from "../mappings/receivable.mapping";

const getReceivableByMonth = async ({venueId, month, year}) => {
    const url = `${VenueManagementUrls.getReceivable}`;
    const body = {
        venueId,
        month,
        year
    }
    try {

        // const response = {
        //     "id": "60eedbd55b3df81a4870ca17",
        //     "venueId": "56cbtbu254gybhy876",
        //     "createdAt": "2021-07-14T12:43:01.642+00:00",
        //     "openingBalance": -5000.0,
        //     "netWeddingzServiceFee": {
        //         "amount": 25000.0,
        //         "socialFields": null,
        //         "corporateFields": null,
        //         "otherWeddingzFee": null,
        //         "cancellationImpact": null,
        //         "modificationImpact": null
        //     },
        //     "pastBookingsImpact": {
        //         "amount": 10000.0,
        //         "cancellationImpact": null,
        //         "modificationImpact": null
        //     },
        //     "reconPaymentSection": {
        //         "amount": 10000.0,
        //         "amountPaidToWeddingz": 0.0,
        //         "paymentsToVendor": 8907.0,
        //         "amountRefundToCustomer": 0.0,
        //         "tdsDeductionByVenue": 0.0,
        //         "paymentsId": null
        //     },
        //     "updatedAt": "2021-07-14T12:43:01.642+00:00",
        //     "month": 7.0,
        //     "year": 2021.0
        // }
        //******* un comment to hit backend api */
        const receivable = await VenueManagementClient.postRequest(url, body)
        .then((response) => response.data)
        .then((response) => mapGetReceivableByMonthyIdResponse(response.data));
        
        console.log("%c Get Receivable : ", "color: yellow", receivable);

        return receivable;
    } catch (err) {
        console.error("Get Receivable by Id Error : ", err);
        throw err
    }
};


const getReceivableStatementByMonth = async ({venueId, month, year, downloadRef}) => {
    const url = `${VenueManagementUrls.getReceivableExcel}`;
    const body = {
        venueId,
        month,
        year
    }
    const header = {
        responseType: "arraybuffer"
    }
    try {

        const receivable_api = await VenueManagementClient.postRequestWithHeader(url, body,header)
        .then(res => {
            
            if(res.headers["content-length"] ==0 ){
                throw new Error(
                    JSON.stringify({
                      status: "CONSTRAINT_ERROR",
                      errorCode: "333",
                      errorType: "CONSTRAINT_ERROR",
                      message: `No Recon data found for ${month} ${year}.`,
                    })
                  );
            }
            return new Blob([res.data]) } )
        .then(blob => {
            let a = downloadRef
            const href = window.URL.createObjectURL(blob);
            a.href = href;
            a.click();
            a.href = '';
        })

        console.log("%c Get Receivable : ", "color: yellow", receivable_api);

        return true;
    } catch (err) {
        console.error("Get Receivable by Id Error : ", err);
        throw err
    }
};

export default {
    getReceivableByMonth: getReceivableByMonth,
    getReceivableStatementByMonth,
}